import React, { Component } from "react";
import { connect } from "react-redux";
import IconButton from "material-ui/IconButton";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import ArrowDropRight from "material-ui/svg-icons/navigation-arrow-drop-right";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import * as uiActions from "../store/ui/uiActions";
import * as scheduleSelectors from "../store/schedule/scheduleSelectors";

class MatchMenu extends Component {
  render() {
    const { showEditResult, showPasswordDialog, match } = this.props;
    const { home, away } = match;
    const text = [
      home + " lämnade WO",
      home + " lämnade WO utan att meddela",
      away + " lämnade WO",
      away + " lämnade WO utan att meddela"
    ];
    return (
      <IconMenu
        desktop={true}
        iconButtonElement={
          <IconButton touch={true}>
            <MoreVertIcon />
          </IconButton>
        }
      >
        <MenuItem onClick={showEditResult} primaryText="Ange resultat" />
        <MenuItem
          primaryText="Walk Over"
          rightIcon={<ArrowDropRight />}
          menuItems={[
            <MenuItem
              key="menu-0"
              onClick={() => showPasswordDialog("home_wo")}
              primaryText={text[0]}
            />,
            <MenuItem
              key="menu-1"
              onClick={() => showPasswordDialog("home_wo_no_notify")}
              primaryText={text[1]}
            />,
            <MenuItem
              key="menu-2"
              onClick={() => showPasswordDialog("away_wo")}
              primaryText={text[2]}
            />,
            <MenuItem
              key="menu-3"
              onClick={() => showPasswordDialog("away_wo_no_notify")}
              primaryText={text[3]}
            />
          ]}
        />
      </IconMenu>
    );
  }
}

const mapStateToProps = (state, initialProps) => {
  const { matchId } = initialProps;
  return {
    match: scheduleSelectors.getMatchById(state, matchId)
  };
};

const mapDispatchToProps = (dispatch, initialProps) => {
  const { matchId } = initialProps;
  return {
    showEditResult: () => dispatch(uiActions.showEditResult(true, matchId)),
    showPasswordDialog: action =>
      dispatch(uiActions.showPasswordDialog(true, matchId, action))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchMenu);



// WEBPACK FOOTER //
// ./src/components/MatchMenu.js